var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"loader"},[_c('svg',{staticClass:"circular-loader",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"loader-path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke":"#ffffff","stroke-width":"2"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }